export default "__VITE_ASSET__ed2c3533__"